import { SELECT_PIPE, SELECT_TOOL_DRAWING_PIPE, BEGIN_DRAWING_PIPE, UPDATE_DRAWING_PIPE, END_DRAWING_PIPE, BEGIN_DRAGGING_PIPE, UPDATE_DRAGGING_PIPE, END_DRAGGING_PIPE } from '../constants';

export function selectPipe(layerID, pipeID) {
  return {
    type: SELECT_PIPE,
    layerID: layerID,
    pipeID: pipeID
  };
}

export function selectToolDrawingPipe(sceneComponentType) {
  return {
    type: SELECT_TOOL_DRAWING_PIPE,
    sceneComponentType: sceneComponentType
  };
}

export function beginDrawingPipe(layerID, x, y, snapMask) {
  return {
    type: BEGIN_DRAWING_PIPE,
    layerID: layerID, x: x, y: y, snapMask: snapMask
  };
}

export function updateDrawingPipe(x, y, snapMask) {
  return {
    type: UPDATE_DRAWING_PIPE,
    x: x, y: y, snapMask: snapMask
  };
}

export function endDrawingPipe(x, y, snapMask) {
  return {
    type: END_DRAWING_PIPE,
    x: x, y: y, snapMask: snapMask
  };
}

export function beginDraggingPipe(layerID, pipeID, x, y, snapMask) {
  return {
    type: BEGIN_DRAGGING_PIPE,
    layerID: layerID, pipeID: pipeID, x: x, y: y, snapMask: snapMask
  };
}

export function updateDraggingPipe(x, y, snapMask) {
  return {
    type: UPDATE_DRAGGING_PIPE,
    x: x, y: y, snapMask: snapMask
  };
}

export function endDraggingPipe(x, y, snapMask) {
  return {
    type: END_DRAGGING_PIPE,
    x: x, y: y, snapMask: snapMask
  };
}